import React, { useEffect, useState } from 'react'
import { ScaleProvider } from './ScaleContext'

const BASE_WIDTH = 1440
const BASE_HEIGHT = 529

const UniversalScaler = ({ children }) => {
  const [scale, setScale] = useState(1)

  const updateScale = () => {
    const widthScale = window.innerWidth / BASE_WIDTH
    const heightScale = window.innerHeight / BASE_HEIGHT
    const newScale = Math.min(widthScale, heightScale)
    setScale(newScale)
  }

  useEffect(() => {
    updateScale()
    window.addEventListener('resize', updateScale)
    return () => window.removeEventListener('resize', updateScale)
  }, [])

  return (
    <ScaleProvider>
      <div
        style={{
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          width: `${BASE_WIDTH}px`,
          height: `${BASE_HEIGHT}px`,
          position: 'absolute',
          // top: '50%',
          // left: '50%',
          // marginTop: `${-(BASE_HEIGHT / 1.3) * scale}px`,
          // marginLeft: `${-(BASE_WIDTH / 2) * scale}px`,
          top: '0',
          left: '0',
        }}
      >
        {children}
      </div>
    </ScaleProvider>
  )
}

export default UniversalScaler
